var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"intro"}},_vm._l((_vm.introContent),function(content){return _c('p',[_vm._v("\n        "+_vm._s(content)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }